<a [routerLink]="[loggedIn ? '/app' : '/']"><img src="assets/logo-jujo.png" style="height: 45px; width: auto;"></a>
<a *ngIf="loggedIn && !canSeeReport" routerLink="/app"><strong>Workflows</strong></a>
<a *ngIf="loggedIn && !canSeeReport" routerLink="/app/archive"><strong>Archive</strong></a>
<a *ngIf="loggedIn && canSeeConfig" routerLink="/app/config"><strong>Configuration</strong></a>
<a *ngIf="loggedIn && canSeeReport" routerLink="/app/report"><strong>Report List</strong></a>

<div class="fill"></div>
<kis-username-menu *ngIf="loggedIn"
                   [user]="user"
                   [canSeeConfig]="canSeeConfig">
</kis-username-menu>
